import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import { FEATURES } from "../../../../../config/features";

const PositionTable = ({ data, onEdit, currentPage, setCurrentPage }) => {
  const headers = [
    ...(FEATURES.POSITION_UNIT_CODE ? ["Unit Code"] : []),
    ...(FEATURES.POSITION_CODE ? ["Code"] : []),
    "Description",
    "Status",
    "Actions"
  ];

  const accessors = [
    ...(FEATURES.POSITION_UNIT_CODE ? ["unitCode"] : []),
    ...(FEATURES.POSITION_CODE ? ["code"] : []),
    "description",
    "isActive",
    "actions"
  ];

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    },
  ];

  const getStatusBadge = (isActive) => (
    isActive
      ? <span className="rounded-full bg-green-100 px-2 py-1 text-xs text-green-800">Active</span>
      : <span className="rounded-full bg-red-100 px-2 py-1 text-xs text-red-800">Inactive</span>
  );

  return (
    <CreateTable
      tableName={"Position List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
      customRenderers={{
        isActive: (val) => getStatusBadge(val)
      }}
    />
  );
};

export default PositionTable;